import * as React from 'react';
import {
    Button,
    Grid, IconButton, InputAdornment,
    TextField
} from "@mui/material";
import {
    ArrowBackIos, ArrowForwardIos, Mail, Visibility, VisibilityOff
} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useState} from "react";
import {selectRequestState, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import Api from "../../inc/Api";
import Pref from "../../inc/Pref";
import {userLoggedIn} from "../../store/userSlice";

function Step3Login() {

    const {item} = useSelector(selectRequestState);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    function login() {

        setLoading(true);
        setError(null);
        Api.post('/client/auth/login', {email: item.client.email, password}, rsp => {
            if (rsp.ok) {

                // logica de login
                Pref.sessionToken = rsp.token;

                verify();

            } else {
                setLoading(false);
                setError(rsp.msg);
            }
        });

    }

    function verify() {
        Api.get('/admin/verify', rsp => {
            if (rsp.ok && rsp.user.data) {
                Pref.sessionUser = rsp.user.data;
                dispatch(userLoggedIn(rsp.user.data));
                console.log('rsp.user.data', rsp.user.data);
                dispatch(setStep('4'));
            } else {
                console.log('no logged');
            }
        });
    }

    return (
        <Body title="Accede a tu cuenta" onSubmit={login}>

            <Grid container spacing={3}>

                <Grid xs={12} md={6} item>

                    <TextField
                        label="Correo electrónico"
                        value={item.client.email}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Mail color="primary"/>
                                </InputAdornment>
                            ),
                        }}
                        disabled/>

                </Grid>

                <Grid xs={12} md={6} item>

                    <TextField
                        label="Contraseña"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                                        {showPassword
                                            ? <VisibilityOff color="primary"/>
                                            : <Visibility color="primary"/>}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                        type={showPassword ? "text" : "password"}
                        disabled={loading}
                        error={!!error}
                        helperText={error}
                        autoFocus/>

                </Grid>

                <Grid xs={12} item>

                    <Button
                        variant="text"
                        style={{
                            textDecoration: 'underline',
                            color         : 'white',
                        }}
                        onClick={() => dispatch(setStep('3_recover'))}>
                        ¿Perdió su contraseña?
                    </Button>

                </Grid>

                <Grid md={6} item display={{xs: 'none', md: 'block'}}/>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        startIcon={<ArrowBackIos/>}
                        onClick={() => {
                            dispatch(setStep('3_check'));
                        }}
                        color="secondary"
                        disabled={loading}
                        fullWidth>
                        Volver
                    </Button>

                </Grid>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        endIcon={!loading && <ArrowForwardIos/>}
                        type="submit"
                        disabled={!item.client.email || loading}
                        fullWidth>
                        {loading ? 'Verificando...' : 'Siguiente'}
                    </Button>

                </Grid>

            </Grid>

        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step3Login));